var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2454 10.4688C11.2454 11.1898 10.9589 11.8813 10.4491 12.3912C9.93919 12.9011 9.24767 13.1875 8.52661 13.1875C7.80555 13.1875 7.11403 12.9011 6.60416 12.3912C6.0943 11.8813 5.80786 11.1898 5.80786 10.4688C5.80786 9.74769 6.0943 9.05617 6.60416 8.5463C7.11403 8.03644 7.80555 7.75 8.52661 7.75C9.24767 7.75 9.93919 8.03644 10.4491 8.5463C10.9589 9.05617 11.2454 9.74769 11.2454 10.4688V10.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99536 2.3125C3.03395 2.3125 2.11192 2.69442 1.4321 3.37424C0.75228 4.05406 0.370361 4.97609 0.370361 5.9375V24.0625C0.370361 25.0239 0.75228 25.9459 1.4321 26.6258C2.11192 27.3056 3.03395 27.6875 3.99536 27.6875H25.7454C26.7068 27.6875 27.6288 27.3056 28.3086 26.6258C28.9884 25.9459 29.3704 25.0239 29.3704 24.0625V5.9375C29.3704 4.97609 28.9884 4.05406 28.3086 3.37424C27.6288 2.69442 26.7068 2.3125 25.7454 2.3125H3.99536V2.3125ZM25.7454 4.125C26.2261 4.125 26.6871 4.31596 27.027 4.65587C27.3669 4.99578 27.5579 5.4568 27.5579 5.9375V17.7188L20.712 14.1898C20.5421 14.1047 20.3496 14.0751 20.162 14.1054C19.9743 14.1356 19.8008 14.2241 19.6662 14.3584L12.9419 21.0827L8.12061 17.871C7.94654 17.7551 7.73774 17.703 7.52962 17.7235C7.32151 17.7439 7.12688 17.8358 6.97874 17.9834L2.18286 22.25V5.9375C2.18286 5.4568 2.37382 4.99578 2.71373 4.65587C3.05364 4.31596 3.51466 4.125 3.99536 4.125H25.7454Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(0.366699 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.732277d962b7f2019dab99fc95e1d0eb.svg";
export { ForwardRef as ReactComponent };